import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        {/* <Parallax bgImage={about} bgImageAlt="Entree Dish" strength={100}>
          <div style={{ height: '365px' }} />
        </Parallax> */}

        <CFView column center>
          <CFImage src={about} w="100%" alt="Food Gallery" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="-3px">
          <CFView
            row
            justifyStart
            alignCenter
            h="500px"
            w="100%"
            maxWidth="1400px"
            image={`url(${about}) center / cover no-repeat`}
            style={{ backgroundAttachment: 'fixed' }}
          ></CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
